import { Injectable } from '@angular/core';
import { HomehuntComponent } from 'src/app/navigation/company-nav-bar/component/homehunt/homehunt.component';
import { DefaultComponent } from './component/default/default.component';

@Injectable({
  providedIn: 'root',
})
export class CompanyNavBarService {
  constructor() { }
  getCompanyComponent(aliasName) {
    if (aliasName == 'homehunt') {
      return { data: null, component: HomehuntComponent };
    }
    // else if (aliasName == 'rubyporch') {
    //   return { data: null, component: RubyporchComponent };
    // } 
    else return { data: null, component: DefaultComponent };
  }
}
